module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment"
  }, [_c('category-menu', {
    attrs: {
      "tempfix": true
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://unpkg.com/simpleslider-js@1.9.0/dist/simpleSlider.min.css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "simple-slider page-slider desktop-slider",
    staticStyle: {
      "width": "100%",
      "max-height": "250px",
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "slider-wrapper"
  }, _vm._l((_vm.desktopBanners), function(item, index) {
    return _c('div', {
      staticClass: "slider-slide",
      staticStyle: {
        "max-height": "250px"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": item.target
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "max-height": "250px",
        "object-fit": "contain"
      },
      attrs: {
        "src": item.img
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "slider-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "slider-btn slider-btn-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "slider-btn slider-btn-next"
  })]), _vm._v(" "), _c('div', {
    staticClass: "simple-slider page-slider mobile-slider",
    staticStyle: {
      "width": "100%",
      "max-height": "500px",
      "margin-top": "-20px",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "slider-wrapper"
  }, _vm._l((_vm.mobileBanners), function(item, index) {
    return _c('div', {
      staticClass: "slider-slide",
      staticStyle: {
        "max-height": "250px"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": item.target
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "max-height": "250px",
        "object-fit": "contain"
      },
      attrs: {
        "src": item.img
      }
    })])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "slider-pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "slider-btn slider-btn-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "slider-btn slider-btn-next"
  })]), _vm._v(" "), (_vm.itemsInCart > 0) ? _c('div', {
    staticClass: "fabContainer"
  }, [_c('div', {
    staticClass: "faButton",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cart'
        })
      }
    }
  }, [_vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.user.role > 0 && _vm.lastordered && _vm.lastordered.length > 0) ? _c('last-ordered-goods') : _vm._e(), _vm._v(" "), _c('top-goods'), _vm._v(" "), _c('new-goods')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fabb ui circular google plus icon button"
  }, [_c('i', {
    staticClass: "cart icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-074c8bdd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage.vue
// module id = 317
// module chunks = 1